import Attribute from './Attribute';
import classes from './AttributeList.module.css';

function AttributeList(props) {
	return (
		<ul className={classes.list}>
			{props.attributes.map((attribute, index) => (
				<Attribute
					key={index}
					attrId={attribute.attributeTypes_id}
					attrName={attribute.attrType}
					attrStyle={attribute.attributeStyles_id}
					values={attribute.values}
					maavStep={attribute.maavStep}
					maavMedia={attribute.maavMedia}
					maavInfo={attribute.maavInfo}
					pricePreview={attribute.pricePreview}
					filter={props.filter}
					selected={props.selected}
					step={props.step}
				/>
			))}	
		</ul>
	);
}

export default AttributeList;